import React, { createContext, useContext } from 'react';

const SmartFitnessContext = createContext(undefined);

export const SmartFitnessProvider = ({ children, value }) => {
    return <SmartFitnessContext.Provider value={value}>{children}</SmartFitnessContext.Provider>;
};

export const useSmartFitnessContext = () => {
    const context = useContext(SmartFitnessContext);
    if (context === undefined) {
        throw new Error('useSmartFitnessContext 必須在 SmartFitnessProvider 中使用');
    }
    return context;
};
